// removed by extract-text-webpack-plugin
module.exports = {"qrCodeContent":"QRCode__qrCodeContent","qrCode":"QRCode__qrCode","stingray":"QRCode__stingray","refreshButton":"QRCode__refreshButton","refreshButtonBackground":"QRCode__refreshButtonBackground","refreshImg":"QRCode__refreshImg","refreshText":"QRCode__refreshText","growDotQello":"QRCode__growDotQello","growDotBlue":"QRCode__growDotBlue","growDotGolden":"QRCode__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QRCode/QRCode.scss
// module id = 1880
// module chunks = 0